import { TableHead } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: "rgb(11, 48, 149)",
}));

export const ModalContainer = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  padding: 16,
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  width: "60vw",
  maxWidth: 600,
  maxHeight: "90vh",
  overflowY: "auto",
  [theme.breakpoints.down("sm")]: {
    width: "95vw",
    maxWidth: "none",
    top: "50%",
    left: "50%",
  },
}));

export const InputContainer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 16,
  "& div": {
    marginBottom: 0,
    width: "100%",
  },

  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: 0,
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
}));

export const ButtonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 16,
  "& button": {
    marginLeft: 16,
  },
}));
export const UserContainter = styled("div")(({ theme }) => ({
  "& h2": {
    fontWeight: 700,
  },
}));
